import { createAsyncThunk } from '@reduxjs/toolkit';
import { eventsApi } from '../../api/events/eventsApi';

// Get event by ID
export const getEventByIdAsyncThunk = createAsyncThunk(
  'event/getEventById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await eventsApi.getEventById(id);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch event'
      );
    }
  }
);

// Get all events with filters
export const getEventsAsyncThunk = createAsyncThunk(
  'event/getEvents',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await eventsApi.getEvents(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch events'
      );
    }
  }
);

// Create event
export const createEventAsyncThunk = createAsyncThunk(
  'event/createEvent',
  async (eventData, { rejectWithValue }) => {
    try {
      const response = await eventsApi.createEvent(eventData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to create event'
      );
    }
  }
);

// Update event
export const updateEventAsyncThunk = createAsyncThunk(
  'event/updateEvent',
  async ({ id, eventData }, { rejectWithValue }) => {
    try {
      const response = await eventsApi.updateEvent(id, eventData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update event'
      );
    }
  }
);

// Delete event
export const deleteEventAsyncThunk = createAsyncThunk(
  'event/deleteEvent',
  async (id, { rejectWithValue }) => {
    try {
      const response = await eventsApi.deleteEvent(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete event'
      );
    }
  }
);

// Get all events without pagination
export const getEventWithoutPaginationAsyncThunk = createAsyncThunk(
  'event/getEventWithoutPagination',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await eventsApi.getEventWithoutPagination(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch events'
      );
    }
  }
);

